import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  slide_bounce_variants,
  slide_bounce_exit_variants,
  slide_bounce_entry_variants,
  bounce_exit_left_variants,
  bounce_entry_right_variants,
  bounce_right_to_left_variants
} from "shared/components/animations";
import bannerLogo from "assets/images/gah/others-banner.png";

const PrePlayCommon = ({ status, playerObj }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="gah-others-common"
    >
      <motion.div
        variants={
          status === "PrePlay"
            ? bounce_right_to_left_variants
            : status === "Reading"
            ? bounce_entry_right_variants
            : status === "Result"
            ? bounce_exit_left_variants
            : {}
        }
        className="top-others-banner"
      >
        <img alt="" src={bannerLogo} />
        <h2 className="banner-text">Just chill for now...</h2>
      </motion.div>
      <motion.div
        variants={
          status === "PrePlay"
            ? slide_bounce_variants
            : status === "Reading"
            ? slide_bounce_entry_variants
            : status === "Result"
            ? slide_bounce_exit_variants
            : {}
        }
        className="gifs-container"
      >
        {playerObj.cards.map((card, index) => (
          <div key={index} className="common-card-wrapper">
            <div className="title-div">
              <h2>{card.text}</h2>
            </div>

            <div className="gif-div">
              <img alt="" src={card.gif_url} />
            </div>
          </div>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default PrePlayCommon;
